'use strict';

angular.module('ClinicApp').directive('primeInvoiceReport', function() {
  return {
    templateUrl: '/views/directives/_prime-invoice-report.html',
    scope: {
      invoiceReport: '=primeInvoiceReport',
      year: '=',
      month: '=',
    },
    link: function(_scope, el) {
      // Enable popovers.
      el.find('[data-toggle="popover"]').popover();
    },
  };
});
